module.exports = __webpack_public_path__ + "static/100--stacked-column-8bc2cd074c3c8e9766a110b852a11782.png";